export const RESOURCE_GROUP_TYPES = {
    RAVEN: "raven",
    VEHICLE: "vehicle",
    ASSET: "asset",
    GEOFENCE: "geofence"
}

export const RESOURCE_ALERT_LEVEL = {
    DEFAULT: "default",
    //INFORMATIONAL: "informational",
    //NOTIFICATION: "notification",
    WARNING: "warning",
    CRITICAL: "critical",
    SEVERE: "severe"
}